import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateTaggedMessages = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 282,
	height: 282,
	viewBox: "0 0 282 282",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 143.274,
			cy: 138.726,
			r: 138.726,
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.619 69.1355L194.671 51.8516L221.052 130.994L150.097 245.613L49.1226 179.206L114.619 69.1355Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M187.376 40.1754L112.86 58.7282L116.484 73.2839L112.86 58.7282C108.383 59.8429 104.551 62.7292 102.245 66.7246L41.3223 172.245C36.6279 180.376 39.4137 190.773 47.5447 195.468L143.255 250.726C151.386 255.42 161.783 252.634 166.477 244.503L227.399 138.983C229.706 134.987 230.29 130.226 229.017 125.791L207.823 51.98C205.297 43.1821 196.258 37.9639 187.376 40.1754ZM191 54.731C192.045 54.4708 193.108 55.0847 193.405 56.1198L214.599 129.931C214.749 130.453 214.68 131.013 214.409 131.483L153.487 237.003C152.934 237.96 151.711 238.288 150.755 237.735L55.0447 182.477C54.0881 181.925 53.7604 180.702 54.3127 179.745L115.235 74.2246C115.506 73.7546 115.957 73.415 116.484 73.2839L191 54.731ZM161.317 126.425C171.077 126.425 178.989 118.513 178.989 108.753C178.989 98.993 171.077 91.081 161.317 91.081C151.557 91.081 143.645 98.993 143.645 108.753C143.645 118.513 151.557 126.425 161.317 126.425Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219.718 229.366L201.588 243.6L224.155 272.346C228.013 277.262 235.124 278.106 240.039 274.248L240.375 273.984C245.291 270.126 246.147 263.027 242.285 258.112L219.718 229.366Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219.718 229.366L201.584 243.601L201.185 243.089C198.305 239.42 198.053 234.542 200.148 230.705L191.526 219.724C192.265 219.313 192.991 218.88 193.692 218.393C194.057 218.171 194.431 217.923 194.767 217.659C195.123 217.419 195.472 217.146 195.808 216.882C196.114 216.639 196.437 216.387 196.735 216.131C197.533 215.459 198.276 214.745 198.985 214.015L207.532 224.904C211.751 223.783 216.435 225.185 219.315 228.854L219.714 229.366H219.718Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.455 147.657C122.343 162.659 119.014 190.335 134.017 209.448C147.576 226.717 171.427 231.108 189.998 220.739L189.969 220.702C190.976 220.148 191.954 219.556 192.937 218.934C193.436 218.599 193.923 218.28 194.393 217.94C194.876 217.616 195.35 217.243 195.808 216.886C196.228 216.559 196.664 216.214 197.067 215.87C198.138 214.942 199.145 213.977 200.106 212.986L200.119 213.003C215.336 197.467 217.048 172.68 203.246 155.099C188.244 135.991 160.568 132.658 141.455 147.661V147.657Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.012 156.006C133.509 167.39 130.982 188.392 142.366 202.891C152.655 215.996 170.756 219.325 184.843 211.458L184.822 211.429C185.586 211.009 186.329 210.56 187.072 210.086C187.454 209.83 187.82 209.586 188.176 209.33C188.542 209.087 188.903 208.801 189.251 208.533C189.57 208.285 189.902 208.025 190.208 207.76C191.018 207.055 191.782 206.325 192.513 205.569L192.525 205.582C204.069 193.79 205.37 174.984 194.897 161.644C183.513 147.145 162.511 144.618 148.012 155.998V156.006Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.736 208.491C187.177 208.491 186.623 208.244 186.25 207.769C185.607 206.951 185.75 205.763 186.569 205.12C192.672 200.331 196.542 193.446 197.47 185.744C198.398 178.041 196.27 170.434 191.48 164.335C181.59 151.738 163.292 149.534 150.695 159.424C149.876 160.066 148.688 159.923 148.046 159.105C147.404 158.286 147.546 157.098 148.365 156.456C162.6 145.282 183.273 147.771 194.448 162.005C199.863 168.902 202.264 177.491 201.219 186.197C200.169 194.903 195.795 202.677 188.898 208.088C188.554 208.361 188.143 208.491 187.736 208.491Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.525 201.905C146.787 201.905 146.056 201.586 145.557 200.969C142.757 197.518 140.805 193.564 139.76 189.211C138.874 185.517 138.698 181.755 139.235 178.028C139.436 176.643 140.713 175.686 142.106 175.883C143.491 176.084 144.453 177.369 144.251 178.754C143.802 181.839 143.949 184.963 144.688 188.027C145.557 191.637 147.173 194.92 149.49 197.778C150.372 198.865 150.204 200.461 149.121 201.342C148.65 201.724 148.088 201.909 147.525 201.909V201.905Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 161.013,
			cy: 109.161,
			r: 10.9161,
			fill: "#DCEBFE"
		})
	]
});
export default SvgEmptyStateTaggedMessages;
